module.exports = __webpack_public_path__ + "assets/img/footer_01.78e68257.png";